"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.workspaceStoreApp = void 0;
var qs = require('qs');
exports.workspaceStoreApp = function (axios) {
    return {
        getStoreApps: function (request) {
            return axios.get('/apps', request);
        },
        getStoreAppsAppNo: function (request) {
            var appNo = request.pathParams.appNo, params = request.params;
            var path = "/apps/" + appNo + (params ? '?' + qs.stringify(params) : '');
            return axios.get(path);
        },
        getStoreAppsAppNoMalls: function (request) {
            var appNo = request.pathParams.appNo;
            return axios.get("/apps/" + appNo + "/malls");
        }
    };
};
